
import { PARKING_ORDER_BY_PRICE } from 'commons/js/constants'

export function byDistanceAsc (computeDistanceToReferencePoint) {
    return (left, right) => {
        const leftDistance = computeDistanceToReferencePoint(left.latitude, left.longitude)
        const rightDistance = computeDistanceToReferencePoint(right.latitude, right.longitude)
        return Math.sign(leftDistance - rightDistance)
    }
}

function byNearestEntranceAsc (computeDistanceToReferencePoint) {
    return (left, right) => {
        const leftNearestEntrance = getNearestEntrance(left, computeDistanceToReferencePoint)
        const rightNearestEntrance = getNearestEntrance(right, computeDistanceToReferencePoint)
        const leftDistance = computeDistanceToReferencePoint(leftNearestEntrance.latitude, leftNearestEntrance.longitude)
        const rightDistance = computeDistanceToReferencePoint(rightNearestEntrance.latitude, rightNearestEntrance.longitude)
        return Math.sign(leftDistance - rightDistance)
    }
}

function byPriceAsc (left, right) {
    const leftPrice = getPriceAmount(left)
    const rightPrice = getPriceAmount(right)
    return Math.sign(leftPrice - rightPrice)
}

function getPriceAmount (parking) {
    return parking && parking.bookingAvailability && parking.bookingAvailability.price_qty ? parking.bookingAvailability.price_qty.amount : 0
}

function getNearestEntrance (parking, computeDistanceToReferencePoint) {
    const [ nearestEntrance ] = [...parking.entrances].sort(byDistanceAsc(computeDistanceToReferencePoint))

    return nearestEntrance
}

export const makeParkingsComparator = (order, computeDistanceToReferencePoint) => {
    return order === PARKING_ORDER_BY_PRICE ? byPriceAsc : byNearestEntranceAsc(computeDistanceToReferencePoint)
}
